import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Auth/comprobarEntornoLocal`, method: 'GET', body: null, token: token})
}
